import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OverlayModule } from '@angular/cdk/overlay';

import { MdePopoverComponent } from './popover';
import { MdePopoverTriggerDirective } from './popover-trigger';
import { MdePopoverTargetDirective } from './popover-target';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  imports: [
    OverlayModule,
    CommonModule,
    A11yModule
  ],
  exports: [MdePopoverComponent, MdePopoverTriggerDirective, MdePopoverTargetDirective],
  declarations: [MdePopoverComponent, MdePopoverTriggerDirective, MdePopoverTargetDirective],
})
export class MdePopoverModule {}
